import { Pipe, type PipeTransform } from '@angular/core';
import { WorkoutType } from '@goatsports/core/data-access';
import { WorkoutTypeNames } from '../constants/workout-type-names';

@Pipe({
  name: 'workoutTypeName',
  standalone: true,
})
export class WorkoutTypeNamePipe implements PipeTransform {
  transform(value: WorkoutType | null | undefined): string {
    if (!value) {
      return WorkoutTypeNames.Unknown;
    }
    return WorkoutTypeNames[value];
  }
}
